module.exports = __webpack_public_path__ + "bg.cc67becf.svg";